// TODO: Deprecate in INT-503.

export function showErrorAlert(message) {
  const root = window.moovaAdmin
  const app = root && root.$root && root.$root.$children[0]
  const simplert = app && app.$refs && app.$refs.simplert

  if (!simplert) {
    console.error('[MVA] ' + message)
    return
  }

  simplert.openSimplert({
    title: 'ERROR',
    message,
    type: 'error'
  })
}
